import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';
import { string } from 'prop-types';

const API_SLUG = 'CostosAño';

export interface CostoAño {
  año: number;
	dni: string;
  costeEmpresa: number;
  HorasConvenio: number;
  PorcentajeIndirectos: number;
  CostoHora: number;
  CostoDirecto: number;
  CostoTotal: number;
  Usuario: string;
  IdCO: string;
}

export class CostosAñoAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarCostosAño(año: number): AxiosPromise<any[]> {
		return this.cliente.get(`/ListarCostosAnio/${año}` );
  }
  
  ListarEjerciciosCostos():  AxiosPromise<number[]> {
		return this.cliente.get(`/ListarEjerciciosCostos` );
  }

	ModificarCosto(costo: any): AxiosPromise<any[]> {
		return this.cliente.put(costo.dni, costo, `/ModificarCosto`);
  }
  
  EliminarCosto(año: number, dni: string): AxiosPromise<any> {
		return this.cliente.removeVarious(dni,año, `/EliminarCosto`);
  }

  EliminarCostos(data: any[]): AxiosPromise<any> {
		return this.cliente.post(data, `/EliminarCostos`);
  }

  CrearCosto(costo:any): AxiosPromise<any[]> {
		return this.cliente.post(costo,`/CrearCosto`);
  }
  
  ImportarCosteAnual(data: any): AxiosPromise<any> {
    const file = data[0];
		var formData = new FormData();
		formData.append("file", file, file.name);
		
		return this.cliente.postFile(formData, `/ImportarCosteAnual`);
	}

  ImportarCPIndirectos(data: any): AxiosPromise<any> {
    var formData = new FormData();
    const file = data[0];
    formData.append("file", file, file.name);
		
		return this.cliente.postFile(formData, `/ImportarCPIndirectos`);
  }
}